/* eslint-disable @typescript-eslint/no-explicit-any */

// Külön ajax wrapper, arra az esetre, ha a 3rd party-t cserélnénk, vagy sajátot írnánk.
// Csak Promise-based ajaxot használunk, bármire is cserélnénk, vagy pedig itt kell
// megvalósítani a Promise-t!

// Végül saját ajax lett
import gokuAjax from '@common/ajax/v1/ajax'

import { is } from '@common/is/is'
import { Object } from '@common/Object/Object'

import type { TRequestMethod } from '@common/http/definitions'

type TData = Record<string, unknown>

export interface IAjaxParams {
  readonly method: TRequestMethod
  readonly timeout: number
  readonly data?: TData
}

const DEFAULT_TIMEOUT = 0

/**
 * Egy Promise-alapú AJAX request kilövése.
 * @param url    - Az url, ahova lőjjük a request-et.
 * @param params - A paraméterek, amiket passzolunk az XHR-nek.
 */
export default function ajax (
  url: string,
  params: IAjaxParams = { method: 'GET', timeout: DEFAULT_TIMEOUT } // eslint-disable-line unicorn/no-object-as-default-parameter
): Promise<any> {
  // --- Ennek a struktúrának így kell maradnia, mert a backend így küldi a választ!
  let data: FormData | TData | undefined = params.data // eslint-disable-line @typescript-eslint/prefer-destructuring

  if (is.defined(params.data)) {
    data = new FormData()

    Object.getKeys(params.data).forEach((key) => {
      if (params.data) {
        (data as FormData).append(key, params.data[key] as any)
      }
    })
  }
  // ---

  return new Promise((resolve, reject) => {
    gokuAjax(url, {
      needXrw: false,
      method: params.method,
      data,
      success: resolve,
      error: reject
    })
  })
}
